import {
  CoordinateAxis,
  MagnitudeUnit,
  ManualDistributedLoad,
  ManualDistributedLoadDefinition,
  ManualLoad,
  ManualLoadDefinition,
} from '@paragon/contract-library';
import {
  distanceEquals,
  distanceGreaterThanOrEqual,
  distanceLessThanOrEqual,
  distributedForceGreaterThan,
  forceGreaterThan,
  stressGreaterThan,
} from '@paragon/geometry-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

interface ComponentBounds {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
}

export const manualLoadCoordinateIsOnComponent =
  (componentBounds: ComponentBounds) => (definitionAxis: CoordinateAxis, coordinate: number) =>
    distanceGreaterThanOrEqual(coordinate, definitionAxis === 'X' ? componentBounds.minX : componentBounds.minY) &&
    distanceLessThanOrEqual(coordinate, definitionAxis === 'X' ? componentBounds.maxX : componentBounds.maxY);

export function manualLoadMagnitudeIsGreaterThanZero(magnitude: number, unit: MagnitudeUnit) {
  switch (unit) {
    case 'Pounds':
      return forceGreaterThan(magnitude, 0);
    case 'PoundsPerLinearFoot':
      return distributedForceGreaterThan(magnitude, 0);
    case 'PoundsPerSquareFoot':
      return stressGreaterThan(magnitude, 0);
    default:
      assertExhaustiveSwitch(unit);
  }
}

export function manualDistributedLoadDefinitionMagnitudeIsGreaterThanZero(
  manualLoadDefinition: ManualDistributedLoadDefinition,
) {
  return (
    manualLoadMagnitudeIsGreaterThanZero(manualLoadDefinition.startMagnitude, manualLoadDefinition.magnitudeUnit) ||
    manualLoadMagnitudeIsGreaterThanZero(manualLoadDefinition.endMagnitude, manualLoadDefinition.magnitudeUnit)
  );
}

export function manualDistributedLoadMagnitudeIsGreaterThanZero(manualLoad: ManualDistributedLoad) {
  return (
    manualLoadMagnitudeIsGreaterThanZero(manualLoad.startMagnitude, manualLoad.magnitudeUnit) ||
    manualLoadMagnitudeIsGreaterThanZero(manualLoad.endMagnitude, manualLoad.magnitudeUnit)
  );
}

export function distributedManualLoadDefinitionHasDifferentStartAndEnd(manualLoadDefinition: ManualLoadDefinition) {
  if (manualLoadDefinition.distribution === 'Concentrated') return true;
  return !distanceEquals(manualLoadDefinition.startCoordinate, manualLoadDefinition.endCoordinate);
}

export function distributedManualLoadHasDifferentStartAndEnd(manualLoad: ManualLoad) {
  if (manualLoad.distribution === 'Concentrated') return true;
  return !distanceEquals(manualLoad.start.x, manualLoad.end.x) || !distanceEquals(manualLoad.start.y, manualLoad.end.y);
}
